// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import Home from './components/Home';
import About from './components/About';
import Blogs from './components/Blogs';
import Contact from './components/Contact';
import DataAnalytics from './components/DataAnalytics';
import BusinessIntelligence from './components/BusinessIntelligence';
import DataEngineering from './components/DataEngineering';
import ArtificialIntelligence from './components/ArtificialIntelligence';
import SoftwareDevelopment from './components/SoftwareDevelopment';
import AppsDevelopment from './components/AppsDevelopment';
import ResourceOutsource from './components/ResourceOutsource';
import Training from './components/Training';
import Banking from './components/Banking';
import HealthCare from './components/HealthCare';
import Retails from './components/Retails';
import Insurance from './components/Insurance';
import Education from './components/Education';
import Manufacturing from './components/Manufacturing';
import CapitalMarkets from './components/CapitalMarkets';
import PublicServices from './components/PublicServices';
import ConsumerGoods from './components/ConsumerGoods';
import HighTech from './components/HighTech';
import Pharmaceutical from './components/Pharmaceutical';
import MediaEntertainment from './components/MediaEntertainment';
import BlogsDetails from './components/BlogsDetails';
import BlogsDetails1 from './components/BlogsDetails1';
import BlogsDetails2 from './components/BlogsDetails2';
import BlogsDetails4 from './components/BlogsDetails4';
import FullStackDevelopment from './components/FullStackDevelopment';
import AIMLEssentials from './components/AIMLEssentials';
import DataVisualizationWithPowerBI from './components/DataVisualizationWithPowerBI';
import TransactionAnalytics from './components/TransactionAnalytics';
import InnovatingforTomorrow from './components/InnovatingforTomorrow';
import DataDrivenDecisions from './components/DataDrivenDecisions';
import EmpoweringGrowth from './components/EmpoweringGrowth';
import FutureReadySolutions from './components/FutureReadySolutions';
import StreamliningProcesses from './components/StreamliningProcesses';
import ITSupport from './components/ITSupport';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/data-analytics" element={<DataAnalytics />} />
        <Route path="/business-intelligence" element={<BusinessIntelligence />} />
        <Route path="/data-engineering" element={<DataEngineering />} />
        <Route path="/artificial-intelligence" element={<ArtificialIntelligence />} />
        <Route path="/software-development" element={<SoftwareDevelopment />} />
        <Route path="/apps-development" element={<AppsDevelopment />} />
        <Route path="/resource-outsource" element={<ResourceOutsource />} />
        <Route path="/training" element={<Training />} />
        <Route path="/it-support" element={<ITSupport />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/healthcare" element={<HealthCare />} />
        <Route path="/retail" element={<Retails />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/education" element={<Education />} />
        <Route path="/manufacturing" element={<Manufacturing />} />
        <Route path="/capital-markets" element={<CapitalMarkets />} />
        <Route path="/public-services" element={<PublicServices />} />
        <Route path="/consumer-goods" element={<ConsumerGoods />} />
        <Route path="/high-tech" element={<HighTech />} />
        <Route path="/pharmaceutical" element={<Pharmaceutical />} />
        <Route path="/media-entertainment" element={<MediaEntertainment />} />
        <Route path="/blog-Details" element={<BlogsDetails />} />
        <Route path="/blog-Details1" element={<BlogsDetails1 />} />
        <Route path="/blog-Details2" element={<BlogsDetails2 />} />
        <Route path="/blog-Details4" element={<BlogsDetails4 />} />
        <Route path="/full-stack-development" element={<FullStackDevelopment />} />
        <Route path="/ai-machine-learning-essentials" element={<AIMLEssentials />} />
        <Route path="/data-visualization-with-PowerBI-tableau" element={<DataVisualizationWithPowerBI />} />
        <Route path="/transaction-analytics" element={<TransactionAnalytics />} />
        <Route path="/innovating-for-tomorrow" element={<InnovatingforTomorrow />} />
        <Route path="/data-driven-decisions" element={<DataDrivenDecisions />} />
        <Route path="/empowering-growth" element={<EmpoweringGrowth />} />
        <Route path="/future-ready-solutions" element={<FutureReadySolutions />} />
        <Route path="/streamlining-processes" element={<StreamliningProcesses />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />

      </Routes>
      <Footer /> 
    </Router>
  );
}

export default App;